// extracted by mini-css-extract-plugin
export default {"DefaultPosition":"Animate_DefaultPosition__xWpHE","FixedPosition":"Animate_FixedPosition__DVZtN","FadeUp":"Animate_FadeUp__kkY+W"};